export default __webpack_public_path__ + "static/media/F4A2C028-36FE-4AF5-9905-4C0AB3B9B2A1_1_105_c.9f7bab20.jpeg";